export const EVENTS = {
	MAKE_EXAMPLE: 'MAKE_EXAMPLE'
}